module.exports = __webpack_public_path__ + "static/media/gb-nir.5329af59.svg";